import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import flexible from '../../../utils/flexible.js';
import exhibitionItemv2 from './components/exhibitionItem';
import qrCode3 from '@/components/qrCode3.vue';
import guideBottom from '@/components/guideBottom.vue';
import guideTheme from '@/components/guideTheme.vue';
import { isWx } from '@/utils/utils';
import bigImg from '../../../components/bigImg.vue';
import hysbwg from '../../../components/hysbwg.vue';
export default {
  name: 'exhibitionsv2',
  data() {
    return {
      isActive: 0,
      bannersList: [],
      //轮播图
      page: 1,
      limit: 50,
      museumCode: 'jnsbwg',
      exhibType: '常设展览',
      //展览类型
      exhibitions: [],
      //展览列表
      inputValue: '',
      //关键词
      nextPage: true,
      //是否存在下一页数据,
      museumName: '',
      formData: {},
      language: 1,
      //中文1 英文0
      showQrcode: false,
      childList: [],
      allExhibitions: [],
      searchBoxFlag: false,
      exhibtypeList: [],
      exhibTypeData: [{
        title: '常设展览',
        en: 'Permanent Exhibition'
      }, {
        title: '临时展览',
        en: 'Temporary Exhibition'
      }, {
        title: '展览',
        en: 'Exhibition'
      }, {
        title: '总馆介绍',
        en: 'Central Introduction'
      }, {
        title: '分馆介绍',
        en: 'Branch Introduction'
      }],
      bannerImgs: []
    };
  },
  components: {
    exhibitionItemv2,
    qrCode3,
    guideBottom,
    guideTheme,
    hysbwg
  },
  created() {
    flexible();
    let e = this.$route.query;
    this.formData = {
      exhibition_formId: 171924,
      audio_formId: 171925,
      banner_formId: 171927,
      fid: e.fid
    };
    if (e.fid == 247145 && e.formId == 2544640) {
      //普陀文化馆的第二个语音导览
      this.formData = {
        exhibition_formId: 2544637,
        audio_formId: 2544640,
        banner_formId: 2544641,
        fid: e.fid
      };
    }
    document.title = '语音讲解';
    this.getBanner();
    this.getExhibitionStruct();
    if (sessionStorage.getItem("language")) this.language = 0;
  },
  methods: {
    // 获取展览表单结构
    getExhibitionStruct() {
      let params = {
        deptId: this.formData.fid,
        formId: this.formData.exhibition_formId
      };
      this.$api.formStruct(params).then(res => {
        if (res.length > 0) {
          res.forEach(elem => {
            if (elem.alias === 'type') {
              this.exhibtypeList = elem.field.options.map(child => {
                let en = '';
                this.exhibTypeData.forEach(item => {
                  if (item.title === child.title) en = item.en;
                });
                let obj = {
                  title: child.title,
                  en: en === '' ? 'Temporary Exhibition' : en
                };
                return obj;
              });
            }
          });
          this.exhibType = this.exhibtypeList[0].title;
        }
        this.getData();
      });
    },
    // 打开展厅讲解
    toExplanation() {
      let query = this.$route.query;
      !this.language ? query.language = 'en' : '';
      this.$router.push({
        name: `explanation`,
        query
      });
    },
    // 打开地图导览
    toArticle() {
      this.$router.push({
        name: `article`,
        query: this.$route.query
      });
    },
    changeLanguage(data) {
      this.language = data;
      !this.language ? sessionStorage.setItem("language", "en") : sessionStorage.removeItem("language");
    },
    search() {
      this.getData();
    },
    typeClick(item, index) {
      this.exhibType = item.title;
      this.isActive = index;
      this.page = 1;
      this.getData();
    },
    showTheme() {
      this.exhibType = '常设展览';
      this.isActive = 1;
      this.page = 1;
      this.getData();
    },
    showtemporary() {
      this.exhibType = '临时展览';
      this.isActive = 2;
      this.page = 1;
      this.getData();
    },
    toBannerExhibition(data) {
      let exhibitionCode = this.allExhibitions.find(item => {
        return item.exhibName == data.exhibition;
      });
      if (!exhibitionCode) return;
      this.$router.push(`/${this.$route.query.fid == 152288 && this.childList.find(c => {
        return c.parentExhibitonName == data.exhibition;
      }) ? 'childExhibitions' : 'audiosv2'}?fid=${this.$route.query.fid}&exhibCode=${exhibitionCode.code}&formId=${this.$route.query.formId}`);
    },
    getBanner() {
      let bannerForm = {
        deptId: this.formData.fid,
        formId: this.formData.banner_formId,
        page: 1,
        limit: 20
      };
      this.$api.singleadvanceSearch(bannerForm).then(res => {
        let list = this.setDatas(res.dataList, 'banner');
        this.bannersList = list;
        this.bannerImgs = this.bannersList.map(item => {
          return item.bannerImage;
        });
        console.log(this.bannerImgs, 'bannerImgs');
        this.$nextTick(() => {
          new Swiper(this.$refs.swiperNav, {
            slidesPerView: 1.2,
            centeredSlides: true,
            spaceBetween: 10,
            touchMoveStopPropagation: true,
            runCallbacksOnInit: false,
            observer: true,
            //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,
            loop: true,
            pagination: {
              el: '.swiper-container .swiper-pagination'
            }
          });
        });
        let share = {
          title: '语音讲解',
          imgUrl: list[0].bannerImage
        };
        isWx().then(type => {
          if (type !== 'mini-wx') this.wechatShare(share);
        });
      });
    },
    getData() {
      const _this = this;
      let searchStr = {
        filters: [],
        model: 0
      };
      if (_this.inputValue) {
        let searchFilters = [{
          "id": 2,
          "alias": "name",
          "compt": "editinput",
          "express": "like",
          "val": _this.inputValue,
          "range": null
        }];
        searchStr.filters.push(searchFilters);
      }
      if (this.$route.query.fid == 152288) {
        let searchFilters = [{
          "id": 11,
          "alias": "11",
          "compt": "selectbox",
          "express": "like",
          "val": ['父级'],
          "range": null
        }];
        searchStr.filters.push(searchFilters);
      }
      let formData = {
        page: 1,
        limit: 50,
        deptId: _this.formData.fid,
        formId: _this.formData.exhibition_formId,
        searchStr: encodeURI(JSON.stringify(searchStr)),
        orderBy: 'manualOrderTop,manualOrder',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        let list = _this.setDatas(res.dataList, 'list');
        this.allExhibitions = list;
        this.exhibitions = list.filter(item => {
          return item.exhibType == this.exhibType;
        });
        if (this.inputValue && !list.length) {
          this.searchAudios();
        }
      });
      if (this.$route.query.fid == 152288) {
        searchStr.filters[searchStr.filters.length - 1][0].val = ['子级'];
        formData.searchStr = encodeURI(JSON.stringify(searchStr));
        //子级列表
        this.$api.singleadvanceSearch(formData).then(res => {
          let list = _this.setDatas(res.dataList, 'list');
          this.childList = list;
        });
      }
    },
    // 搜索语音详情名称
    searchAudios() {
      let searchStr = {
        filters: [[{
          alias: 'explainObj',
          compt: "editinput",
          express: 'like',
          range: null,
          val: this.inputValue
        }]],
        model: 0
      };
      let data = {
        page: 1,
        limit: 50,
        deptId: this.formData.fid,
        formId: this.formData.audio_formId,
        searchStr: encodeURI(JSON.stringify(searchStr)),
        orderBy: 'manualOrder',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(data).then(res => {
        if (!res.dataList.length) return this.exhibitions = [];
        this.$router.push(`/audiosv2?fid=${this.$route.query.fid}&searchKey=${this.inputValue}&formId=${this.$route.query.formId}`);
      });
    },
    setDatas(data, type) {
      return data.map(item => {
        return type == 'banner' ? {
          bannerImage: this.getFormData(item, 'image', 'fileUrl'),
          bannerName: this.getFormData(item, 'name', 'val'),
          exhibition: this.getFormData(item, 'exhibition', 'val'),
          englishName: this.getFormData(item, 'english_name', 'val')
        } : {
          exhibName: this.getFormData(item, 'name', 'val'),
          price: this.getFormData(item, 'expend', 'val'),
          exhibType: this.getFormData(item, 'type', 'val'),
          images: this.getFormData(item, 'image', 'fileUrl'),
          exhibitionLocation: this.getFormData(item, 'address', 'val'),
          exhibBegin: this.getFormData(item, 'startTime', 'val'),
          exhibEnd: this.getFormData(item, 'endTime', 'val'),
          code: this.getFormData(item, 10, 'val'),
          en_name: this.getFormData(item, 'en_name', 'val'),
          en_location: this.getFormData(item, 'en_location', 'val'),
          en_desc: this.getFormData(item, 'en_desc', 'val'),
          parentExhibitonName: this.getFormData(item, 12, 'val')
        };
      });
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey]) return '';
      let target = data[Tkey].groupValues[0];
      if (!target) return '';
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    },
    wechatShare(share) {
      return;
      let apiurl = '';
      if (location.protocol == 'http:') {
        apiurl = 'http://map.museum.chaoxing.com/beacon/config';
      } else if (location.protocol == 'https:') {
        apiurl = 'https://map-museum.chaoxing.com/beacon/config';
      }
      var promise = new Promise((resove, reject) => {
        this.$ajax({
          url: apiurl + "?url=" + window.location.href,
          methods: 'get'
        }).then(res => {
          // console.log(res)
          resove(res);
          // this.config = res
        }).catch(err => {
          console.log(err, 'wxerr');
          reject(err);
        });
      });
      promise.then(data => {
        wx.config({
          debug: false,
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.data.appId,
          // 必填，公众号的唯一标识
          timestamp: data.data.timestamp,
          // 必填，生成签名的时间戳
          nonceStr: data.data.nonceStr,
          // 必填，生成签名的随机串
          signature: data.data.signature,
          // 必填，签名，见附录1
          jsApiList: ['updateAppMessageShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        // console.log(share)
        var shareConfig = {
          share: {
            imgUrl: share.imgUrl === undefined ? '' : share.imgUrl,
            // 分享图标
            desc: share.desc === undefined ? '' : share.desc,
            // 分享描述
            title: document.title,
            // 分享标题
            link: window.location.href,
            // 分享出去后的链接，这里可以将链接设置成另外一个页面，必须在同一域名下面
            success: function () {
              // 分享成功之后的回调
            },
            cancel: function () {
              // 用户取消分享后执行
            },
            fail: function (res) {
              alert(JSON.stringify(res));
            }
          }
        };
        // console.log(shareConfig,'share')
        wx.ready(function () {
          wx.updateAppMessageShareData(shareConfig.share);
          wx.error(function (res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            alert(JSON.stringify(res));
          });
          wx.checkJsApi({
            jsApiList: ['updateAppMessageShareData'],
            // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              console.log(JSON.stringify(res));
            }
          });
        });
      });
    }
  }
};